import Vue from 'vue'

Vue.component('EcoConduiteComponent', () =>
  import('@c/desktop/EcoConduite/EcoConduiteComponent.vue')
)

Vue.component('EcoConduiteNav', () =>
  import('@c/desktop/EcoConduite/EcoConduiteNav.vue')
)
